/* Mountain Sports â€” Returns & Exchanges page
   Single behavior: FAQ accordion toggle. The contact form is a
   standard Shopify {% form 'contact' %}, no JS needed. */
(function () {
  function initFaq(root) {
    var items = root.querySelectorAll('[data-ms-r-faq-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-ms-r-faq-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function init() {
    initFaq(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();